import { useMemo, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import { DebtReportPage } from "./DebtReport";
import { DebtWarehousePage } from "./DebtWarehouse";
import { DebtSalesPage } from "./DebtSales";

const DebtPage = () => {
  const [sumWhouseId, setSumWHouseId] = useState();
  const [queryParams] = useQueryParams();
  const { userMe } = useAuthGlobal();

  const subName = useMemo(() => {
    switch (queryParams?.tab) {
      case "debt-sales":
        return "Công nợ sales";
      case "report":
        return "Xuất báo cáo";
      default:
        return "Công nợ kho";
    }
  }, [queryParams]);

  return (
    <>
      <PageHeader
        name="Quản lý Công nợ"
        subName={subName}
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
      {queryParams?.tab === "debt" && <DebtWarehousePage />}
      {queryParams?.tab === "debt-sales" && <DebtSalesPage />}
      {queryParams?.tab === "report" && <DebtReportPage />}
    </>
  );
};

export default DebtPage;
